/*
 * TODO remove this file: move all integration specific stuff to each theme instead of getting it at runtime
 */

const configByAppSource = (config, defaults) =>
    (typeof window.APP_SOURCE != 'undefined' && config[window.APP_SOURCE]) || defaults;

export {configByAppSource};
